module.exports = __webpack_public_path__ + "static/media/johnson-fitout.0730cde0.png";